<template>
  <v-menu
    v-model="menuOpen"
    location="top end"
    origin="overlap"
    :close-on-click="false"
    :close-on-content-click="false"
    max-width="300px"
    min-width="300px"
  >
    <template #activator="{ props }">
      <v-btn v-bind="props" :block="$vuetify.display.mdAndDown">
        <v-icon class="mr-2">mdi-calendar</v-icon>
        <span>{{ filterLabel || 'Date Filters' }}</span>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        Filter by Date
        <v-spacer />
        <v-btn icon @click="menuOpen = false"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-select
              :model-value="timePeriod"
              label="Select time period"
              :items="timePeriodItems"
              item-title="text"
              clearable
              @update:model-value="$emit('update:timePeriod', $event)"
            />
          </v-col>
        </v-row>
        <v-row v-if="timePeriod === 'date_range'">
          <v-col cols="6">
            <CommonDatePicker
              label="From"
              left
              :enter-date="dateFrom"
              :hide-details="false"
              @updateDate="$emit('update:dateFrom', $event)"
            />
          </v-col>
          <v-col cols="6">
            <CommonDatePicker
              label="To"
              left
              :enter-date="dateTo"
              :hide-details="false"
              @updateDate="$emit('update:dateTo', $event)"
            />
          </v-col>
        </v-row>
        <v-row v-if="timePeriod">
          <v-col cols="12">
            <v-btn-toggle
              :model-value="dateToggle"
              mandatory
              class="d-flex flex-grow-1"
              @update:model-value="$emit('update:dateToggle', $event)"
            >
              <v-btn class="flex-grow-1" value="paid">
                Paid Date
              </v-btn>
              <v-btn class="flex-grow-1" value="due">
                Due Date
              </v-btn>
            </v-btn-toggle>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn class="cancel" variant="outlined" @click="$emit('click:clear')">Clear</v-btn>
        <v-spacer />
        <v-btn class="primary" data-track="report.open-balances-dates.apply" @click="applyHandler">Apply</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import { ITextValue } from '@/types/common';

import CommonDatePicker from '@/components/common-components/pickers/CommonDatePicker.vue';

interface IData {
  timePeriodItems?: ITextValue<string>[];
  menuOpen: boolean;
}

export default defineComponent({
  name: 'OpenBalancesDateFilter',

  components: { CommonDatePicker },

  props: {
    filterLabel: {
      type: String,
      default: '',
    },
    timePeriod: {
      type: String,
      default: '',
    },
    dateFrom: {
      type: String,
      default: '',
    },
    dateTo: {
      type: String,
      default: '',
    },
    dateToggle: {
      type: String,
      default: 'paid',
    },
  },

  emits: ['click:apply', 'click:clear', 'update:dateFrom', 'update:dateTo', 'update:dateToggle', 'update:timePeriod'],

  data: (): IData => ({ menuOpen: false }),

  created () {
    this.timePeriodItems = [
      { text: 'This Calendar Month', value: 'month' },
      { text: 'This Calendar Year', value: 'year' },
      { text: 'Date Range', value: 'date_range' },
    ];
  },

  methods: {
    applyHandler () {
      this.menuOpen = false;
      this.$emit('click:apply');
    }
  }
})
</script>
